<div style="text-align: center">
  <h3>{{ 'Page Not Found' | t }}</h3>
  <p>{{ "Make sure the address is correct and the page hasn't moved." | t }}</p>
</div>
